import { type Registry as Services, service } from '@ember/service';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { ManagementFeeRuleValidation } from 'uplisting-frontend/validations';
import { type IErrorResult } from 'uplisting-frontend/services/http-client';

interface ICalculateSample {
  formula: string;
}

export interface ICalculateSampleResult {
  formula: string;
  amount: number;
  variables: {
    accommodation_total: number;
    total_payout: number;
  };
}

interface ICalculateSampleResponse {
  data: {
    attributes: ICalculateSampleResult;
  };
}

export default class ManagementFeeRuleRepositoryService extends BaseRepositoryService<
  ModelRegistry['management-fee-rule']
> {
  @service httpClient!: Services['http-client'];

  recordName = 'management-fee-rule';
  implementMethods = [
    'findAll',
    'createRecord',
    'buildChangeset',
    'findRecord',
    'destroyRecord',
  ];

  validation = ManagementFeeRuleValidation;

  public async calculateSample(
    data: ICalculateSample,
  ): Promise<ICalculateSampleResult | IErrorResult> {
    const response =
      await this.httpClient.postJSONApi<ICalculateSampleResponse>(
        'v2/management_fee_rule_samples',
        {
          attributes: data,
        },
      );

    if ((response as IErrorResult).isError) {
      return response as IErrorResult;
    }

    return (response as ICalculateSampleResponse).data.attributes;
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/management-fee-rule': ManagementFeeRuleRepositoryService;
  }
}
